import { changeHistoryContent, dateContent, userContent } from './helpers';

const config = {
  // Table Columns
  columns: [
    {
      title: 'Change Date',
      dataIndex: 'change_date',
      sorter: false,
      defaultSortOrder: 'ascend',
      width: '50px',
      render: (text, record) => dateContent(text, record)
    },
    {
      title: 'User',
      dataIndex: 'user__email',
      sorter: false,
      defaultSortOrder: 'ascend',
      width: '50px',
      render: (text, record) => userContent(text, record)
    },
    {
      title: 'Changes',
      dataIndex: 'change_history',
      sorter: false,
      width: '200px',
      render: (text, record) => changeHistoryContent(text, record)
    }
  ],
  // Filtering
  sorter: {
    field: 'name',
    order: 'ascend'
  },
  filters: {},
  customFilters: {},
  // General
  commands: {
    showDelete: false,
    showAdd: false
  },
  showHeader: true,
  showPagination: true,
  classes: 'bhp-approved-route-list bhp-container'
};

export default config;
